import { handleActions } from 'redux-actions'
import Immutable from 'immutable'

import * as actions from '../actions/customer';

const initialState = Immutable.fromJS({
  data: [],
  loading: false,
  loaded: false
})

export default handleActions({
  [actions.getCustomerSucceeded] (state, { payload }) {
    return state.set('loading', false).set('loaded', true)
      .set('data', Immutable.fromJS(payload.data));
  },
  [actions.getCustomerFailed] (state, action) {
    return state.set('loading', false)
      .merge(Immutable.fromJS({ error: action.payload }))
  },
  [actions.addCustomerSucceeded] (state, { payload }) {
    return state.set('loading', false).set('loaded', true)
      .set('data', Immutable.fromJS(payload.data));
  },
  [actions.addCustomerFailed] (state, action) {
    return state.set('loading', false)
      .merge(Immutable.fromJS({ error: action.payload }))
  }
}, initialState)



// WEBPACK FOOTER //
// ./reducers/customer.js